export default __webpack_public_path__ + "static/2dDesign-dd1d1bc3529581594db02f9db7d55b4a.png";